import React from 'react';
import { TableCell, TableHead, TableRow } from '@mui/material';
import useTranslate from '../../../../../customHooks/useTranslate';

interface MembersTableSectionHeaderProps {
    isOpen: boolean;
    visibleSegmentName?: boolean;
}
const MembersTableSectionHeader = (props: MembersTableSectionHeaderProps) => {
    const { isOpen, visibleSegmentName } = props;
    const translate = useTranslate();

    return (
        <TableHead>
            {isOpen ? (
                <TableRow>
                    <TableCell className='text-capitalize'>
                        {translate('connected')}
                    </TableCell>
                    <TableCell className='text-capitalize'>
                        {translate('name')}
                    </TableCell>
                    {visibleSegmentName && (
                        <TableCell className='text-capitalize'>
                            {translate('type')}
                        </TableCell>
                    )}
                    <TableCell className='text-capitalize'>
                        {translate('country')}
                    </TableCell>
                    <TableCell className='text-capitalize'></TableCell>
                </TableRow>
            ) : (
                ''
            )}
        </TableHead>
    );
};

export default MembersTableSectionHeader;
